/**
 * Registered reminder email template (HTML) — Dutch.
 * Placeholders use {{key}} syntax.
 * Editable sections use {{emailHeadingRow}}, {{emailBodyRow}}, {{emailEventDetailsHeadingRow}}, {{emailEventDetailsSubtextRow}} (hidden when empty).
 */
export const DEFAULT_REGISTERED_REMINDER_EMAIL_TEMPLATE_HTML_DUTCH = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml"
      xmlns:v="urn:schemas-microsoft-com:vml"
      xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="format-detection" content="telephone=no" />
    <meta name="format-detection" content="date=no" />
    <meta name="format-detection" content="address=no" />
    <meta name="format-detection" content="email=no" />
    <title>Geregistreerde herinnering � {{event.title}}</title>

    <!--[if gte mso 9]>
      <xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG />
          <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
      </xml>
    <![endif]-->

    <style type="text/css">
        /* Reset styles */
        body {
            margin: 0 !important;
            padding: 0 !important;
            -webkit-text-size-adjust: 100% !important;
            -ms-text-size-adjust: 100% !important;
            -webkit-font-smoothing: antialiased !important;
        }

        img {
            border: 0 !important;
            outline: none !important;
            display: block;
        }

        table {
            border-collapse: separate !important;
            mso-table-lspace: 0pt !important;
            mso-table-rspace: 0pt !important;
        }

        td {
            border-collapse: separate !important;
        }

        a {
            text-decoration: none;
        }

        /* Client-specific styles */
        .ReadMsgBody {
            width: 100%;
        }

        .ExternalClass {
            width: 100%;
        }

            .ExternalClass,
            .ExternalClass p,
            .ExternalClass span,
            .ExternalClass font,
            .ExternalClass td,
            .ExternalClass div {
                line-height: 100%;
            }

        /* iOS blue links */
        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
        }

        /* Gmail blue links */
        u + #body a {
            color: inherit;
            text-decoration: none;
            font-size: inherit;
            font-family: inherit;
            font-weight: inherit;
            line-height: inherit;
        }

        /* Email body lists (ordered/unordered) so they display in preview */
        .email-body-content ol,
        .email-body-content ul {
            margin: 0.5em 0;
            padding-left: 1.5em;
            text-align: left;
        }
        .email-body-content li {
            margin: 0.25em 0;
        }

        /* Responsive styles */
        @media only screen and (max-width: 600px) {
            .wrapper {
                width: 100% !important;
            }

            .container {
                width: 100% !important;
                padding-left: 20px !important;
                padding-right: 20px !important;
            }

            .mobile-padding {
                padding-left: 15px !important;
                padding-right: 15px !important;
            }

            .mobile-hide {
                display: none !important;
            }

            .mobile-text-center {
                text-align: center !important;
            }
        }
    </style>
</head>

<body id="body" style="margin: 0; padding: 0">
    <!-- Preheader text (hidden) -->
    <div style="
        display: none;
        font-size: 1px;
        color: #e94e1b;
        line-height: 1px;
        max-height: 0px;
        max-width: 0px;
        opacity: 0;
        overflow: hidden;
      ">
        {{event.description}}
    </div>

    <!-- Main wrapper table -->
    <table role="presentation"
           width="100%"
           border="0"
           cellspacing="0"
           cellpadding="0">
        <tr>
            <td align="center" style="padding: 40px 20px">
                <!-- 600px container -->
                <table role="presentation"
                       class="wrapper"
                       width="600"
                       border="0"
                       cellspacing="0"
                       cellpadding="0"
                       style="
              width: 600px;
              max-width: 100%;
              background-color: {{Primary_Color}};
              border-radius: 16px;
              overflow: hidden;
              box-shadow: 0px 25px 50px -12px #00000040;
            ">
                    <!-- Header with logo -->
                    <tr>
                        <td align="center"
                            style="padding: 32px 40px 24px 40px; background-color: #ffffff">
                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td align="center">
                                        <div style="display:flex;justify-content:center;align-items:center;width:130px;height:130px;border:1px solid #000000;border-radius:500px;">
                                            <img src="{{branding.logoUrl}}"
                                                 alt="{{branding.logoAlt}}"
                                                 style=" display: block; width:100px; height:auto;object-fit:contain; margin:0 auto;" />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- Exclusive Event Badge -->
                    {{emailBadgeRow}}
                    <!-- Hero image -->
                    {{HeaderImageBlock_START}}<tr>
                        <td align="center"
                            style="padding: 16px 40px 16px 40px; background-color: #ffffff">
                            <img src="{{Rectangle.Img}}" alt="" style="max-width:504px;height:100%;width:100%;border-radius:32px" />
                        </td>
                    </tr>{{HeaderImageBlock_END}}
                    {{emailHeadingRow}}

                    {{emailBodyRow}}

                    <!-- Event details section -->
                    <tr>
                    
                        <td style="padding: 40px 40px 32px 40px">
                            <table role="presentation"
                                   width="100%"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   style="
                    background-color: #ffffff;
                    border-radius: 16px;
                    padding: 32px;
                  ">
                                <tr>
                                    <td style="padding: 0px">
                                        <table role="presentation"
                                               width="100%"
                                               border="0"
                                               cellspacing="0"
                                               cellpadding="0">
                                            {{emailEventDetailsHeadingRow}}
                                            {{emailEventDetailsSubtextRow}}

                                            <!-- Date row -->
                                            <tr>
                                                <td style="
                              padding-bottom: 16px;
                              width: 50%;
                              vertical-align: top;
                              padding-right: 8px;
                            ">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Date.Icon}}"
                                                                     alt="Date"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0 0 4px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      font-weight: 400;
                                      color: #637381;
                                      line-height: 16px;
                                      text-transform: uppercase;
                                      letter-spacing: 0.5px;
                                    ">
                                                                    Datum
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 500;
                                      color: #161c24;
                                      line-height: 20px;
                                    ">
                                                                    {{emailDate}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <!-- Time -->
                                            </tr>
                                            <tr>
                                                <td style="
                              padding-bottom: 16px;
                              width: 50%;
                              vertical-align: top;
                            ">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Time.Icon}}"
                                                                     alt="Time"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0 0 4px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      color: #637381;
                                      line-height: 16px;
                                      text-transform: uppercase;
                                      letter-spacing: 0.5px;
                                    ">
                                                                    Tijd
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 500;
                                      color: #161c24;
                                      line-height: 20px;
                                    ">
                                                                    {{emailTime}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <!-- Location row -->
                                            <tr>
                                                <td colspan="2">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Location.Icon}}"
                                                                     alt="Location"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0 0 4px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      font-weight: 400;
                                      color: #637381;
                                      line-height: 16px;
                                      text-transform: uppercase;
                                      letter-spacing: 0.5px;
                                    ">
                                                                    Locatie
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 500;
                                      color: #161c24;
                                      line-height: 20px;
                                    ">
                                                                    {{emailLocation}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
<!-- Divider before Referred by -->
                    <tr>
                        <td style="padding: 0 40px 32px 40px">
                            <table role="presentation"
                                   width="100%"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td style="
                        border-top: 1px solid #575756;
                        height: 1px;
                        line-height: 1px;
                        font-size: 1px;
                      ">
                                        &nbsp;
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- welcome image -->
                    <tr>
                        <td style="padding: 0 40px 8px 40px">
                            <table role="presentation"
                                   width="100%"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0">
                                {{FeatureImageBlock_START}}<tr>
                                    <td>
                                        <img src="{{Welcome.Img}}" alt="" style="max-width:504px;height:100%;width:100%;border-radius:32px" />
                                    </td>
                                </tr>{{FeatureImageBlock_END}}
                            </table>
                        </td>
                    </tr>

                    <!-- Referred by section -->
                    <tr>
                        <td style="padding: 0 40px 0px 40px">
                            <h2 style="
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 20px;
                    color: {{Contrast_Color}};
                    line-height: 20px;
                    font-weight: 400;
                  ">
                                Uw uitnodiging
                            </h2>
                            <h6 style="
                    margin: 0 0 24px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 16px;
                    color: {{Contrast_Color}};
                    line-height: 24px;
                    font-weight: 400;
                  ">
                                Deze uitnodiging is met u gedeeld door:
                            </h6>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 0 40px 32px 40px">
                            <table role="presentation"
                                   width="100%"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   style="padding: 20px">
                                <tr>
                                    <td>
                                        <table role="presentation"
                                               width="100%"
                                               border="0"
                                               cellspacing="0"
                                               cellpadding="0">
                                            <!-- Name -->
                                            <tr>
                                                <td style="padding-bottom: 12px">
                                                    <table role="presentation"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="32"
                                                                style="
                                    vertical-align: middle;
                                    padding-right: 10px;
                                  ">
                                                                <img src="{{Dot.Icon}}"
                                                                     alt="Location"
                                                                     width="32"
                                                                     height="32"
                                                                     style="
                                      display: block;
                                      width: 32px;
                                      height: 32px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: middle">
                                                                <p style="
                                      margin: 0 0 2px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      font-weight: 500;
                                      color: {{Contrast_Color}};
                                      line-height: 16px;
                                    ">
                                                                    Naam
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 400;
                                      color: {{Contrast_Color}};
                                      line-height: 20px;
                                    ">
                                                                    {{referrer.name}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <!-- Company -->
                                            <tr>
                                                <td style="padding-bottom: 12px">
                                                    <table role="presentation"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="32"
                                                                style="
                                    vertical-align: middle;
                                    padding-right: 10px;
                                  ">
                                                                <img src="{{Dot.Icon}}"
                                                                     alt="Location"
                                                                     width="32"
                                                                     height="32"
                                                                     style="
                                      display: block;
                                      width: 32px;
                                      height: 32px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: middle">
                                                                <p style="
                                      margin: 0 0 2px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      font-weight: 500;
                                      color: {{Contrast_Color}};
                                      line-height: 16px;
                                    ">
                                                                    Bedrijf
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 400;
                                      color: {{Contrast_Color}};
                                      line-height: 20px;
                                    ">
                                                                    {{referrer.company}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <!-- Email -->
                                            <tr>
                                                <td>
                                                    <table role="presentation"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="32"
                                                                style="
                                    vertical-align: middle;
                                    padding-right: 10px;
                                  ">
                                                                <img src="{{Dot.Icon}}"
                                                                     alt="Location"
                                                                     width="32"
                                                                     height="32"
                                                                     style="
                                      display: block;
                                      width: 32px;
                                      height: 32px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: middle">
                                                                <p style="
                                      margin: 0 0 2px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      font-weight: 500;
                                      color: {{Contrast_Color}};
                                      line-height: 16px;
                                    ">
                                                                    E-mail
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 400;
                                      color: {{Contrast_Color}};
                                      line-height: 20px;
                                    ">
                                                                    {{referrer.email}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- Footer -->
                    <tr>
                        <td align="center"
                            style="padding: 32px 40px; background-color: #f9fafb">
                            <p style="
                    margin: 0 0 8px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 20px;
                    text-align: center;
                  ">
                                Heeft u vragen?
                            </p>
                            <p style='
                    margin: 0 0 20px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, "Segoe UI",
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 14px;
                    color: {{Primary_Color}};
                    line-height: 20px;
                    text-align: center;
                  '>
                                <a href="mailto:{{branding.contactEmail}}"
                                   style="color: {{Primary_Color}}; text-decoration: none">Neem contact op met ons evenemententeam</a>
                            </p>

                            <!-- Social icons -->
                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   align="center">
                                <tr>
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.facebook}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation"
                                                   border="0"
                                                   cellspacing="0"
                                                   cellpadding="0"
                                                   
>
                                                <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center"
                                                        valign="middle"
                                                        style="line-height: 0">
                                                        <img src="{{Facebook.Icon}}"
                                                             alt="Facebook"
                                                             width="16px"
                                                             height="16px"
                                                             style="
                                  display: block;
                                  width: 16px;
                                  height: 16px;
                                " />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.instagram}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation"
                                                   border="0"
                                                   cellspacing="0"
                                                   cellpadding="0"
                                                 
                          ">
                                                <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center"
                                                        valign="middle"
                                                        style="line-height: 0">
                                                        <img src="{{Instagram.Icon}}"
                                                             alt="Instagram"
                                                             width="16px"
                                                             height="16px"
                                                             style="
                                  display: block;
                                  width: 16px;
                                  height: 16px;
                                " />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.linkedin}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation"
                                                   border="0"
                                                   cellspacing="0"
                                                   cellpadding="0"
                                          
                          ">
                                                <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center"
                                                        valign="middle"
                                                        style="line-height: 0">
                                                        <img src="{{LinkedIn.Icon}}"
                                                             alt="LinkedIn"
                                                             width="16px"
                                                             height="16px"
                                                             style="
                                  display: block;
                                  width: 16px;
                                  height: 16px;
                                " />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   align="center"
                                   style="margin-top: 24px; margin-bottom: 24px; width: 100%">
                                <tr>
                                    <td style="
                        border-top: 1px solid #9a9a983d;
                        height: 1px;
                        line-height: 1px;
                        font-size: 1px;
                      ">
                                        &nbsp;
                                    </td>
                                </tr>
                            </table>

                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   align="center"
                                   style="margin-bottom: 16px">
                                <tr>
                                    <td align="center">
                                        <table role="presentation"
                                               border="0"
                                               cellspacing="0"
                                               cellpadding="0">
                                            <tr>
                                              
                                                <td style="vertical-align: middle; padding-right: 8px">
                                                    <img src="{{VDK.Icon}}"
                                                         alt="VDK Logo"
                                                        
                                                         style="display: block; width: 80px; height: auto" />
                                                </td>
                                          
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>

                            <p style="
                    margin: 0 0 4px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 12px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 18px;
                    text-align: center;
                  ">
                                © 2026 VDK Groep. Alle rechten voorbehouden.
                            </p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
export const DEFAULT_NEW_EVENT_REGISTERED_REMINDER_EMAIL_BODY_DUTCH = '{"emailHeading":"<p>Nog 2 dagen te gaan<br />{{sys:eventName}}</p>","emailBody":"<p>De tijd vliegt voorbij. {{sys:eventName}} is nog maar 2 dagen verwijderd.<br />We zijn blij dat je erbij bent. Neem even de tijd om de details hieronder te bekijken en zorg ervoor dat het in je agenda staat.</p>","emailEventDetailsHeading":"Evenementdetails","emailEventDetailsSubtext":"Een opmerkelijk evenement wacht op jou","emailBadge":"Exclusief Evenement","emailButtonText":"Details bekijken"}';
/**
 * Default placeholder values for Registered reminder email preview (Dutch).
 */
export const DEFAULT_EMAIL_PLACEHOLDER_VALUES_REGISTERED_REMINDER_DUTCH = {
    emailBadge: 'Exclusief Evenement',
    emailHeading: 'Nog 2 dagen te gaan <br />{{sys:eventName}}',
    emailBody: '<p>De tijd vliegt voorbij. {{sys:eventName}} is nog maar 2 dagen verwijderd.<br />We zijn blij dat je erbij bent. Neem even de tijd om de details hieronder te bekijken en zorg ervoor dat het in je agenda staat.</p>',
    emailEventDetailsHeading: 'Evenementdetails',
    emailEventDetailsSubtext: 'Een opmerkelijk evenement wacht op jou',
    emailDate: '{{sys:eventDate}}',
    emailTime: '{{sys:eventStartTime}} - {{sys:eventEndTime}}',
    emailLocation: '{{sys:eventLocation}}',
    'sys:eventName': 'Evenementnaam',
    'sys:eventDescription': 'Beschrijving van het evenement',
    'sys:eventDate': '15 maart 2026',
    'sys:eventStartDate': '15 maart 2026',
    'sys:eventEndDate': '15 maart 2026',
    'sys:eventStartTime': '10:00',
    'sys:eventEndTime': '18:00',
    'sys:eventLocation': 'Voorbeeldstraat 123<br />Amsterdam',
    'event.title': 'Evenementnaam',
    'event.description': 'Beschrijving van het evenement',
    'event.date': '15 maart 2026',
    'event.timeStart': '10:00',
    'event.timeEnd': '18:00',
    'event.location.address': 'Voorbeeldstraat 123',
    'event.location.city': 'Amsterdam',
    'event.confirmUrl': '#',
    Primary_Color: '#e94e1b',
    Contrast_Color: '#161c24',
    'branding.logoUrl': '{{branding.logoUrl}}',
    'branding.logoAlt': 'Logo',
    'branding.contactEmail': 'events@example.com',
    'branding.socialLinks.facebook': '#',
    'branding.socialLinks.instagram': '#',
    'branding.socialLinks.linkedin': '#',
    'Rectangle.Img': '/assets/images/rectangle.png',
    HeaderImageBlock_START: '',
    HeaderImageBlock_END: '',
    'Welcome.Img': '/assets/images/welcome.png',
    FeatureImageBlock_START: '',
    FeatureImageBlock_END: '',
    'Date.Icon': '',
    'Time.Icon': '',
    'Location.Icon': '',
    'Arrow.Icon': '',
    'Dot.Icon': '',
    'Facebook.Icon': '/assets/images/social-media-icons/facebook-icon.png',
    'Instagram.Icon': '/assets/images/social-media-icons/instagram-icon.png',
    'LinkedIn.Icon': '/assets/images/social-media-icons/linkedin-icon.png',
    'VDK.Icon': '/assets/images/vdkLogo-nl.svg',
    'referrer.name': 'Jan Jansen',
    'referrer.company': 'Bedrijf',
    'referrer.email': 'jan@example.com'
};
